import React from 'react'
import "../Styles/Tour_information.css"
import { NavLink, Outlet } from 'react-router-dom'

function Tour_information() {
  return (
    <div className='tourInfo_container'>
      <h2 className='tourInfo_title'>Hotel Information</h2>
      <div className='tourInfo_card'>
        <div className='tourInfo_section_navber' style={{overflowX:"auto"}}>
          <NavLink to={"/profile/hotel-info"} end className={({ isActive }) => 
              isActive ? "tourInfo_link active" : "tourInfo_link" 
            }>
            Booked
          </NavLink>
          <NavLink to={"/profile/hotel-info/pending"} className={({ isActive }) =>
              isActive ? "tourInfo_link active" : "tourInfo_link"
            }>
           Payment Pending
          </NavLink>
          {/* <NavLink to={"/profile/hotel-info/bookedmarked"} className={({ isActive }) =>
              isActive ? "tourInfo_link active" : "tourInfo_link"
            }>
            Bookmarked
          </NavLink> */}
          {/* <NavLink to={"/profile/hotel-info/reviews"} className={({ isActive }) =>
              isActive ? "tourInfo_link active" : "tourInfo_link"
            }>
            Reviews
          </NavLink> */}
        </div>
        <hr/>
        {/* tour info content */}
        <div>
          <Outlet/>
        </div>
        </div>
    </div>
  )
}

export default Tour_information